import { buildApiUrl, requestJson } from "../dataProvider/requestJson";

/**
 * Admin team list (`/restapi/admin/teams`, system administrators only, reads included).
 * Contract: docs/drafts/teams-admin-filters.md §3.
 */
const BASE = "admin/teams";

const STATUS_MESSAGES = {
  401: "Your session has expired. Log in again.",
  403: "Only system administrators can list teams.",
};

/** `?a=1&b=x`, skipping null, undefined and blank values. */
export const buildQuery = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === "string" && value.trim() === "") return;
    usp.append(key, String(value));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

export const teamAdminApi = {
  /**
   * @returns {Promise<{totalPages, currentPage, totalElements, teamsDto}>}
   */
  list: (params) =>
    requestJson(
      buildApiUrl(`${BASE}${buildQuery(params)}`),
      undefined,
      STATUS_MESSAGES,
    ),

  /** @returns {Promise<{divisions: {value, count}[], teamTypes: {code, label, count}[]}>} */
  filterOptions: () =>
    requestJson(
      buildApiUrl(`${BASE}/filter-options`),
      undefined,
      STATUS_MESSAGES,
    ),
};
